import { isNumber } from 'lodash';
import Select from 'react-select';
import { useAppSelector } from 'store';
import {
  composableFiltersState,
  FilterProps,
  MainOperatorEnum,
} from 'store/composableFiltersSlice';

interface ClausePrefixProps {
  index: number;
  handleSelectOperator: Function;
  parentIndex?: number;
}

export const ClausePrefix = ({
  index,
  handleSelectOperator,
  parentIndex,
}: ClausePrefixProps) => {
  const { selected } = useAppSelector(composableFiltersState);

  let currentFilters = {} as FilterProps;

  if (isNumber(parentIndex)) {
    const parent = selected.filters.conditions[parentIndex];
    if (parent.type === 'groupedFilterClause') {
      currentFilters = parent;
    }
  } else {
    currentFilters = selected.filters;
  }

  const selectBaseStyles = {
    input: (base: any) => ({
      ...base,
      'input:focus': {
        boxShadow: 'none',
      },
    }),
    control: (base: any) => ({
      ...base,
      backgroundColor: '#F8F8F8',
      border: 'none',
      borderRadius: '8px',
      height: '48px',
      width: '83px',
      textTransform: 'capitalize',
    }),
    menu: (base: any) => ({
      ...base,
    }),
    indicatorSeparator: () => ({}),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: '16px',
    }),
  };

  const operatorOptions = [
    {
      value: MainOperatorEnum.And,
      label: 'And',
    },
    {
      value: MainOperatorEnum.Or,
      label: 'Or',
    },
  ];

  if (index === 0) {
    return <p className="w-20 text-right">Where</p>;
  }

  if (index === 1) {
    return (
      <Select
        className=""
        value={{
          value: currentFilters.mainOperator,
          label: currentFilters.mainOperator as string,
        }}
        isSearchable={false}
        options={operatorOptions}
        onChange={(selectedOption) => {
          handleSelectOperator(selectedOption);
        }}
        styles={selectBaseStyles}
      />
    );
  }
  if (index > 1) {
    return (
      <p className="w-20 text-right capitalize">
        {currentFilters.mainOperator}
      </p>
    );
  }

  return null;
};
